export const getParentPath = (path: string) => path.replace(/\.*?([A-Za-z0-9_-]*?)$/, '');

export const replaceLastPathLevel = (path: string, newField) =>
  getNewPath(getParentPath(path), newField);

export const getNewPath = (path: string, newField) =>
  `${path ? path + '.' : ''}${newField}`;
